type TabOptionsProps = {
  options: string[];
  selectedOption: string;
  onSelectOption: (option: string) => void;
};

export const TabOptions = (props: TabOptionsProps) => {
  return (
    <div className="w-full overflow-x-auto pb-2 scrollbar-hide">
      <div className="flex gap-2 min-w-max">
        {props.options.map((option, index) => (
          <button
            key={index}
            onClick={() => props.onSelectOption(option)}
            className={`${
              props.selectedOption === option
                ? "bg-[hsl(var(--primary))] text-white shadow-md"
                : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
            } px-4 py-2.5 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabOptions;
